<div class="alert-panel" [ngStyle]="{ 'display': showAlert ? 'flex' : 'none' }">
  <div class="panel-content update-available">
    <div translate>{{ eventAlert && eventAlert.description }}</div>
    <div class="actions">
      <a (click)="onClick()" translate>{{ eventAlert && eventAlert.action | uppercase }}</a>
    </div>
  </div>
</div>
